import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;
  flex: 1;

  ${({ isMobile }) =>
    isMobile &&
    css`
      padding: 0 10%;
      margin-top: 0;
      margin-bottom: 16px;
    `}
`;

export const LinkWrapper = styled.div`
  color: ${props =>
    (props.desabledPin ? '#9e9e9e' : '#0B79D0')};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${props => (props.desabledPin ? 'not-allowed' : 'pointer')};
  margin-top: ${props => (props.desabledPin ? '4px' : 'unset')};

  &:hover {
    opacity: ${props => (props.desabledPin ? 'unset' : 0.7)};
  }
`;

export const LinkText = styled.span`
  font-style: italic;
  font-weight: bold;
  font-size: 8px;
  line-height: 8px;
  text-transform: uppercase;
  text-decoration: ${props => (props.desabledPin ? 'none' : 'underline')};
  margin-right: 2px;
`;
